export function IconDocumentCopy({ className }: Readonly<{ className?: string }>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.333 10.75V14.25C13.333 17.167 12.167 18.333 9.25 18.333H5.75C2.833 18.333 1.667 17.167 1.667 14.25V10.75C1.667 7.833 2.833 6.667 5.75 6.667H9.25C12.167 6.667 13.333 7.833 13.333 10.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.333 5.75V9.25C18.333 12.167 17.167 13.333 14.25 13.333H13.333V10.75C13.333 7.833 12.167 6.667 9.25 6.667H6.667V5.75C6.667 2.833 7.833 1.667 10.75 1.667H14.25C17.167 1.667 18.333 2.833 18.333 5.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
